var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.864 1.34792C17.988 0.471918 16.572 0.471918 15.696 1.34792L14.492 2.54792L18.408 6.46392L19.612 5.25992C20.488 4.38392 20.488 2.96792 19.612 2.09192L18.864 1.34792ZM6.896 10.1479C6.652 10.3919 6.464 10.6919 6.356 11.0239L5.172 14.5759C5.056 14.9199 5.148 15.2999 5.404 15.5599C5.66 15.8199 6.04 15.9079 6.388 15.7919L9.94 14.6079C10.268 14.4999 10.568 14.3119 10.816 14.0679L17.508 7.37192L13.588 3.45192L6.896 10.1479ZM3.84 3.03992C1.72 3.03992 0 4.75992 0 6.87992V17.1199C0 19.2399 1.72 20.9599 3.84 20.9599H14.08C16.2 20.9599 17.92 19.2399 17.92 17.1199V13.2799C17.92 12.5719 17.348 11.9999 16.64 11.9999C15.932 11.9999 15.36 12.5719 15.36 13.2799V17.1199C15.36 17.8279 14.788 18.3999 14.08 18.3999H3.84C3.132 18.3999 2.56 17.8279 2.56 17.1199V6.87992C2.56 6.17192 3.132 5.59992 3.84 5.59992H7.68C8.388 5.59992 8.96 5.02792 8.96 4.31992C8.96 3.61192 8.388 3.03992 7.68 3.03992H3.84Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.063f35b3429ee7524a0f74f37f1f1b14.svg";
export { ForwardRef as ReactComponent };